<template>
  <footer>
    <!-- <small>Created by <a href="https://twitter.com/_hdong">Hao Dong</a> <i class="fa fa-copyright" aria-hidden="true"></i> {{year}}</small> -->
    <small><i class="fa fa-copyright" aria-hidden="true"></i> {{year}}</small>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: '2018',
    };
  },
  created() {
    const date = new Date();
    if (date) this.year = date.getFullYear();
  },
};
</script>

<style lang="scss" scoped>
  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    width: 100%;
    padding: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue